/**
 * 高级查询相关逻辑
 */
import templateUtil from '../../../static/js/templateUtil'
import objectUtil from '../../../static/js/objectUtil'

const getValue = objectUtil.getValueByPath
//根据配置设置默认值
export function setDefaultVal(criteriaFormDefData) {
  const numberTypeArray = ['FLOAT', 'DOUBLE', 'DECIMAL', 'MONEY', 'LONG', 'INTEGER']
  const temp = {}
  const items = criteriaFormDefData.items // 侧滑高级差询条件
  const groups = criteriaFormDefData.groups // 分组查询条件
  if (items) {
    for (let i = 0; i < items.length; i++) {
      let item = items[i]
      if (item.property && item.defaultValue) {
        // defaultValue 缺省值
        let defaultValue = templateUtil.compileData(item.defaultValue, {})
        if (numberTypeArray.indexOf(item.type.code) > -1) defaultValue = Number(defaultValue) //数据类型是number的话转换为number
        temp[item.property] = defaultValue
      }
    }
  }
  if (groups) {
    for (let i = 0; i < groups.length; i++) {
      let group = groups[i]
      if (group.property && group.chosen) {
        temp[group.property] = true
      }
    }
  }
  return temp
}

//handleChangeBorthersParameter
// 依照 changeBorthers 对象进行联动处理查询参数
// handleCloseQueryParamterItemShow 调用处：crudQuery.vue 1453 行
export function handleChangeBorthersParameter(item, page, criteriaItems) {
  if (!criteriaItems || !Array.isArray(criteriaItems)) {
    return
  }

  // 从 criteriaItems 中找到匹配的项
  let matchedItem = null
  for (let i = 0; i < criteriaItems.length; i++) {
    if (criteriaItems[i].property === item.property) {
      matchedItem = criteriaItems[i]
      break
    }
  }

  // 如果没有找到匹配项或没有 changeBorthers 配置，直接返回
  if (!matchedItem || !matchedItem.parameter || !matchedItem.parameter.changeBorthers) {
    return
  }

  const changeBorthers = matchedItem.parameter.changeBorthers

  // 获取当前字段的值（在调用时已被设置为 null）
  const val = page[item.property]

  // 准备用于模板编译的数据上下文
  const propsCompileData = page || {}

  // 临时存储需要更新的字段值
  const temp = {}

  // 遍历 changeBorthers 配置的每个字段
  Object.keys(changeBorthers).forEach((im) => {
    const otherFields = changeBorthers[im]

    // 如果值为 null 或 undefined，直接设置为对应值（清空该字段）
    if (!otherFields) {
      temp[im] = otherFields
    }
    // 如果值是模板字符串（以 {{ 开头并以 }} 结尾），则使用模板编译
    else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
      temp[im] = templateUtil.compileData(otherFields, propsCompileData)
    }
    // 否则，从当前字段值中根据路径获取值
    else {
      temp[im] = getValue(val, otherFields)
    }
  })

  console.log('******handleChangeBorthersParameter***********', temp)

  // 将处理后的值设置到查询参数中
  Object.keys(temp).forEach((im) => {
    page[im] = temp[im]
  })
}
